export default __webpack_public_path__ + "star-half-empty.png";